<script setup>
import { computed, ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

const props = defineProps({
  initialContent: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
});
const emit = defineEmits(['confirm']);
const dialogRef = ref(null);
const content = ref('');
const isInvalid = computed(() => !content.value.trim());

const open = () => {
  content.value = props.initialContent;
  dialogRef.value?.open();
};
const close = () => dialogRef.value?.close();
const confirm = () => emit('confirm', content.value.trim(), close);

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Editar mensagem para todos"
    description="A alteração será enviada ao WhatsApp antes de aparecer no atendimento."
    confirm-button-label="Salvar alteração"
    :is-loading="isLoading"
    :disable-confirm-button="isInvalid"
    @confirm="confirm"
  >
    <TextArea v-model="content" class="w-full" :max-length="4096" auto-height />
  </Dialog>
</template>
